module.exports = __webpack_public_path__ + "images/kaitori_bonus_cp_lp/mainvisual-date-sp_62d23ad316fc0a77bc69db62cecf597b.png";